import { db } from './Database';

export interface LpnNumber {
    id?: number;
    lpnNo: string;
    endStatusPallet: string;
    rqlState: 'yes' | 'no';
    palletId: number;
    createdAt?: string;
    updatedAt?: string;
}

export class LpnService {
    // Get LPN numbers for a pallet
    static async getLpnNumbers(palletId: number): Promise<{ lpnNumbers: LpnNumber[] }> {
        try {
            const lpnNumbers = await db.palletLpnNumbers
                .where('palletId')
                .equals(palletId)
                .toArray();
            console.log(lpnNumbers, 'lpnNumbers')
            return {
                // message: "Success",
                lpnNumbers: lpnNumbers || []
            };
        } catch (error) {
            console.error('Error getting LPN numbers:', error);
            throw error;
        }
    }

    // Create or update LPN numbers
    static async createLpnNumbers(data: { palletId: number, lpnNumbers: LpnNumber[] }): Promise<{ lpnNumbers: LpnNumber[] }> {
        const { palletId, lpnNumbers } = data;
        console.log(palletId, lpnNumbers, 'palletId, lpnNumbers')
        // return await db.transaction('rw', [db.pallets, db.palletLpnNumbers], async () => {
            try {
                const pallet = await db.pallets.get(palletId);
                if (!pallet) {
                    throw new Error('Pallet not found');
                }

                const createdOrUpdatedLpnNumbers: LpnNumber[] = [];
                const timestamp = new Date().toISOString();

                for (const lpn of lpnNumbers) {
                    if (lpn.id) {
                        // Update existing LPN
                        await db.palletLpnNumbers.update(lpn.id, {
                            ...lpn,
                            updatedAt: timestamp
                        });
                        const updated = await db.palletLpnNumbers.get(lpn.id);
                        if (updated) createdOrUpdatedLpnNumbers.push(updated);
                    } else {
                        // Create new LPN
                        const id = await db.palletLpnNumbers.add({
                            ...lpn,
                            palletId,
                            createdAt: timestamp,
                            updatedAt: timestamp
                        });
                        const created = await db.palletLpnNumbers.get(id);
                        if (created) createdOrUpdatedLpnNumbers.push(created);
                    }
                }

                return {
                    // message: 'Success',
                    // pallet,
                    lpnNumbers: createdOrUpdatedLpnNumbers
                };
            } catch (error) {
                console.error('Error creating/updating LPN numbers:', error);
                throw error;
            }
        // });
    }
}
